import {standardizePhoneNumber} from '@/lib/phone-utils';
import * as yup from 'yup';

export const otpLoginFormSchemaForExistingUser = yup.object().shape({
    code: yup.string().required('otp-code-required').notOneOf(['']),
});

export const otpLoginFormSchemaForNewUser = yup.object().shape({
    email: yup.string().email('error-email-format').required('error-email-required'),
    name: yup.string().required('error-name-required'),
    code: yup.string().required('error-code-required'),
});

export const checkoutContactSchema = yup.object({
    phone_number: yup
        .string()
        .required('error-contact-required')
        .test('phone-validation', 'Số điện thoại không hợp lệ', function (value) {
            const formatPhone = standardizePhoneNumber(`+${value}`);
            const phone = '0' + formatPhone?.slice(3);
            if (phone.length !== 10) {
                return false;
            }
            const phoneWithoutRegionCodeRegex = /^(0[3|5|7|8|9])+([0-9]{8})\b/g;
            const isValid = phoneWithoutRegionCodeRegex.test(phone);
            return isValid;
        }),
});
